import { render, staticRenderFns } from "./vTitle.vue?vue&type=template&id=f72cefa2&scoped=true&"
import script from "./vTitle.vue?vue&type=script&lang=js&"
export * from "./vTitle.vue?vue&type=script&lang=js&"
import style0 from "./vTitle.vue?vue&type=style&index=0&id=f72cefa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72cefa2",
  null
  
)

export default component.exports